import { Button } from "@molecules";

export const SectionEmptyCard = ({
  description,
  button,
}: {
  description: string;
  button: { label: string; onClick: () => void };
}) => {
  return (
    <div className="px-4 sm:px-6 md:px-8 flex flex-col gap-5 ">
      <p className="text-mapiq-black-500">{description}</p>
      <Button
        className="self-start"
        iconRight="plus"
        onClick={button.onClick}>
        {button.label}
      </Button>
    </div>
  );
};
